import { isNil } from "lodash";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import type { UnderwritingStatus } from "@covertree/new-business-graphql";
import { selectPolicy } from "@covertree/new-business-redux";
import { useNewBusinessSelector } from "@covertree/new-business-redux";

import { UWReviewHeader } from "./UWReviewHeader";
import { UWReviewRequired } from "./UWReviewRequired";
import { D2CStepsList } from "./UWReviewStepsLists";

interface UWReviewProps {
  isD2C?: boolean;
  underwritingDecision?: UnderwritingStatus;
}

export function UWReview({
  isD2C = false,
  underwritingDecision,
}: UWReviewProps) {
  const { selectedQuoteLocator, policyLocator } =
    useNewBusinessSelector(selectPolicy)!;

  if (!isD2C) {
    return (
      <UWReviewRequired
        identifiers={[
          { label: "Quote ID", value: selectedQuoteLocator },
          { label: "Policy ID", value: policyLocator },
        ]}
        notes={underwritingDecision?.notes?.filter((note) => !isNil(note))}
      />
    );
  }

  return (
    <Stack>
      <UWReviewHeader title="Insurance review process" />
      <Box mb={5}>
        Your property is unique, so our team will take a deeper look to make
        sure your coverage is personalized to you.
      </Box>
      <Typography fontWeight={500}>Completed steps:</Typography>
      <Box component="ul" sx={{ paddingInlineStart: "20px" }}>
        <Typography component="li" color="primary">
          Submit your application
        </Typography>
      </Box>

      <Typography fontWeight={500}>Next steps:</Typography>
      <D2CStepsList />
    </Stack>
  );
}
